import axios from 'axios'

/**
 * 线索提交接口（首页「申请体验」弹窗与页脚留言共用同一入口）
 *
 * 说明：地址沿用项目线上既有接口，避免出现多个不一致的域名。
 * 后续接入环境变量时，只需把 LEAD_ENDPOINT 改成
 * `${process.env.VUE_APP_API_BASE}/esleepApi/api/submitForm.php` 即可。
 */
export const LEAD_ENDPOINT = 'https://sleeptight-ibs.com/esleepApi/api/submitForm.php'

export function submitLead({ name = '', phone = '', email = '', sex = '', age = null, text = '' } = {}) {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('phone', phone)
  formData.append('email', email)
  formData.append('sex', sex)
  formData.append('text', text)
  formData.append('age', age)

  return axios.post(LEAD_ENDPOINT, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
